import { API_END_POINTS } from './networks/apiEndPoints';
import api from './networks/api';

export const getFilter = async (payload) => {
  try {
    const response = await api.get(API_END_POINTS.GET_FILTER, { params: payload });

    if (response.data?.errorCode === 200) {
      if (!response.data.responseData) {
        throw new Error('No filter data returned');
      }
      return response.data.responseData;
    } else {
      throw new Error(response.data?.errorMessage || 'Failed to fetch slot config day filter');
    }
  } catch (error) {
    console.error('Error fetching slot config day filter:', error);
    throw error;
  }
};

